import { createContext, useContext, useState, useEffect } from 'react'
import { iniciarSync, detenerSync, onSyncEstado } from '../db/sync'
import { useLicencia } from './LicenciaContext'

const SyncContext = createContext(null)

/**
 * estados posibles:
 *  'inactivo'    — sin plan sync o sync desactivado
 *  'conectando'  — iniciando conexión
 *  'activo'      — sincronizando normalmente
 *  'pausado'     — sin cambios pendientes, conexión en espera
 *  'error'       — error de conexión o credenciales
 */
export function SyncProvider({ children }) {
  const { licencia } = useLicencia()
  const [estado, setEstado] = useState('inactivo')
  const [ultimaSync, setUltimaSync] = useState(null)

  // Suscribirse a eventos del módulo sync
  useEffect(() => {
    const unsub = onSyncEstado((nuevoEstado, detalle) => {
      setEstado(nuevoEstado)
      if ((nuevoEstado === 'activo') && detalle instanceof Date) {
        setUltimaSync(detalle)
      }
    })
    return unsub
  }, [])

  // Auto-start si la licencia tiene plan sync con credenciales
  useEffect(() => {
    if (
      licencia?.plan === 'sync' &&
      licencia.syncUrl &&
      licencia.syncUser &&
      licencia.syncPass
    ) {
      iniciarSync(licencia.syncUrl, licencia.syncUser, licencia.syncPass, licencia.dbPrefix)
    } else {
      detenerSync()
      setEstado('inactivo')
    }

    return () => detenerSync()
  }, [licencia])

  const tienePlanSync = licencia?.plan === 'sync'

  return (
    <SyncContext.Provider value={{ estado, ultimaSync, tienePlanSync }}>
      {children}
    </SyncContext.Provider>
  )
}

export function useSync() {
  return useContext(SyncContext)
}
